import { action, observable } from 'mobx';
import {
  isRequired,
  isEmail,
  MobxField,
  IMobxForm,
  MobxFormClass
} from '@app/src/common/components/form/MobxForm';
import { MobxFieldControl } from '@app/src/common/components/form/MobxFieldControl';
import notificationService from '@app/src/services/notification-service/NotificationService';
import UserManagementRepository from '@app/src/common/repository/UserManagementRepository';

export type ForgotPasswordFormState = ForgotPasswordFormStore & IMobxForm;

export class ForgotPasswordFormStore extends MobxFormClass {
  @observable loading: boolean = false;
  @observable isSend: boolean = false;

  @isRequired()
  @isEmail()
  @MobxField()
  email: MobxFieldControl;

  @action
  sendToken = async () => {
    this.loading = true;
    try {
      await UserManagementRepository.sendResetPasswordLetter(this.email.value);
      this.isSend = true;
      notificationService.successMessage('notification.reset-password.success');
    } catch (error) {
      notificationService.errorMessage('notification.reset-password.error');
    } finally {
      this.loading = false;
    }
  };
}

export default ForgotPasswordFormStore;
